export const MAX_SEARCH_HOTEL_DAYS = 28;
export const MAX_NUMBER_OF_ROOMS = 9;
export const MAX_ADULTS = 10;
export const DEFAULT_ADULTS = 2;
